export default (window.__heraldbee_config);